export default __webpack_public_path__ + "static/media/kitchen-table.827bfc73.jpg";